import { Dispatch, SetStateAction } from 'react';
import { UseQueryResult, useQuery } from 'react-query';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { templateIndustriesListKey } from '../constants';
import { templeteIndustries } from '../api/constants';

type useGetTemplateIndustriessProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    enabled: boolean
};

export const useGetTemplateIndustries = ({
    setErrorText = () => { },
    enabled,
}: useGetTemplateIndustriessProps) => {

    const { data: industriesList, isFetching: isLoadingIndustriesList }: UseQueryResult<any, any> = useQuery({
        queryKey: [templateIndustriesListKey],
        enabled: enabled,
        queryFn: () =>

            axiosInstance
                .get(templeteIndustries + '?draw=10')
                .then((res) => res.data),
        onSuccess: (data) => {
            setErrorText('');
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });

    return {
        industriesList,
        isLoadingIndustriesList,
    };
};
